import type { ICard } from "../../cardsSlice";

export const major10Card: ICard = {
    id: "major_10",
    arcana: "major",
    number: 10,
    suit: "major",
    court: "major",
    name: "Колесо Фортуны",
    nameEn: "The Wheel of Fortune",
    keywords: ["Перемены", "Циклы", "Судьба"],
    symbolism: [
      "Большое колесо с буквами Т-А-Р-О",
      "Фигуры Сфинкса, змеи, Анубиса",
      "Символы четырёх стихий"
    ],
    symbolismInterpretation:
      "Изображает цикличность, непостоянство, игру судьбы и повороты жизни",
    archetype: "Колесо времени, архетип перемен и переходов",
    psychology: "Принятие неизбежности изменений, осознание жизненных циклов",
    upright: {
      personality: "Гибкость, готовность адаптироваться",
      relationships: "Новый этап, неожиданные повороты",
      work: "Удачный шанс, перемены в карьере",
      spirituality: "Понимание циклов и закономерностей жизни",
      examples: ["Благоприятный поворот", "Переход к новому", "Окончание одного этапа"]
    },
    reversed: {
      meaning: "Застой, сопротивление переменам, потеря опоры",
      nuances: "Чувство фатальности, утрата контроля"
    },
    associations: ["Судьба", "Круг", "Цикл", "Изменение"],
    combinations: ["С Солнцем — успех после перемен", "С Башней — разрушительные изменения"],
    readingTips: ["Принять неизбежность перемен", "Понимать, что всё возвращается"],
    selfQuestions: ["Как я воспринимаю перемены?", "Какой цикл завершается?"]
  };


